<template>
  <modal :show="show" @update:show="$emit('update:show', $event)">
    <div class="box">
      <div slot="header">
        {{ $t('editQuota') || 'Thay đổi Quota' }}
      </div>

      <div class="content">
        <div class="field">
          <label class="label">{{ $t('maxQuotaGB') || 'Max Quota (GB)' }}</label>
          <div class="control">
            <input
              v-model="maxQuotaGB"
              class="input"
              :class="{ 'is-danger': error }"
              type="number"
              step="0.1"
              min="0.1"
              :placeholder="$t('enterQuota') || 'Nhập quota (GB)'"
              @keyup.enter="handleSave"
            >
          </div>
          <p v-if="error" class="help is-danger">{{ error }}</p>
          <p class="help">
            {{ $t('currentValue') || 'Giá trị hiện tại' }}: {{ formatBytes(currentMaxBytes) }}
          </p>
        </div>
      </div>

      <div slot="footer" class="field is-grouped is-grouped-right">
        <div class="control">
          <button
            type="button"
            class="button is-link is-light"
            @click="$emit('update:show', false)"
          >
            {{ $t('cancel') || 'Hủy' }}
          </button>
        </div>
        <div class="control">
          <button
            type="button"
            class="button is-primary"
            @click="handleSave"
          >
            {{ $t('save') || 'Lưu' }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from '@cyradar/ui'

export default {
  name: 'QuotaSettingsModal',
  components: { Modal },
  props: {
    show: { type: Boolean, default: false },
    currentMaxBytes: { type: Number, default: 0 }
  },
  data () {
    return {
      maxQuotaGB: '',
      error: ''
    }
  },
  watch: {
    show (val) {
      if (val) {
        // Pre-fill with current value in GB
        this.maxQuotaGB = this.currentMaxBytes > 0
          ? String(Math.round((this.currentMaxBytes / (1024 * 1024 * 1024)) * 10) / 10)
          : ''
        this.error = ''
      }
    }
  },
  methods: {
    formatBytes (bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    validate () {
      const val = parseFloat(this.maxQuotaGB)
      if (!this.maxQuotaGB || isNaN(val) || val <= 0) {
        this.error = this.$t('quotaMustBePositive') || 'Phải lớn hơn 0'
        return false
      }
      this.error = ''
      return true
    },
    handleSave () {
      if (!this.validate()) return
      this.$emit('save', Math.round(parseFloat(this.maxQuotaGB) * 1024 * 1024 * 1024))
    }
  }
}
</script>
